import { useSectionFieldsValidation } from './useSectionFieldsValidation';
import { useBirthdayValidation } from './useBirthdayValidation';
import scroll from 'utilities/scroll';
import { useSecondLastNameValidation } from './useSecondLastNameValidation';
import { useResidentValidation } from './useResidentValidation';
import { useInvitationDocNumberValidation } from './useInvitationDocNumberValidation';
import { useInitialStepForm } from '../../../InitialStepForm/context/InitialStepFormContext/InitialStepFormContext';

export const usePersonalDataValidations = ({
    userProfile,
    userProfileForm,
    formActions,
    isValidatingTin,
    isPassportRequired,
    isResident,
    handleValidateSection,
}) => {
    const { handleShowAdvise } = useInitialStepForm();
    const { isFormWithErrors, onValidateSection } = useSectionFieldsValidation({
        userProfile,
        userProfileForm,
        formActions,
        isValidatingTin,
        isPassportRequired,
        handleValidateSection,
    });

    const { isValidDate, handleValidateBirthDate } = useBirthdayValidation({
        userProfile,
        formActions,
        handleIsOlder: isOlder => {
            handleShowAdvise({
                underage: !isOlder,
                ...(!isOlder && { resident: false, jointHolder: false }),
            });
            if (!isOlder) {
                const ageDisclosureElement = document.getElementById('ageRestriction');
                scroll.transition(ageDisclosureElement, 'top');
            }
        },
        handleIsVulnerablyOlder: isVulnerablyOlder => {
            handleShowAdvise({
                vulnerablyOlder: isVulnerablyOlder,
                ...(isVulnerablyOlder && { underage: false, resident: false, jointHolder: false }),
            });
        },
    });
    const { handleSecondLastNameValidation } = useSecondLastNameValidation({ userProfile, formActions });
    const { handleValidateResident } = useResidentValidation({ handleShowAdvise });
    useInvitationDocNumberValidation({
        userProfile,
        userProfileForm,
        onValidation: isValidDocNumberMatch => {
            handleShowAdvise({
                jointHolder: !isValidDocNumberMatch,
                underage: isValidDocNumberMatch && userProfile.isOlder === false,
                resident: isValidDocNumberMatch && userProfile.resident && !isResident,
            });
        },
    });

    return {
        onValidateSection,
        handleValidateBirthDate,
        handleSecondLastNameValidation,
        handleValidateResident,
        isFormWithErrors,
        isValidDate,
    };
};
